import { render, staticRenderFns } from "./TranUserPackageActivityReminderView.vue?vue&type=template&id=6ea16695"
import script from "./TranUserPackageActivityReminderView.vue?vue&type=script&lang=js"
export * from "./TranUserPackageActivityReminderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports